export const getPrefixFromEnvServer = (): string => {
	const portalTypeStr = process.env.NUXT_PUBLIC_PORTAL_TYPE || 'master';

	switch (portalTypeStr.toLowerCase()) {
	case 'phd':
	case 'short':
	case 'distance_learning':
		return '';
	default:
		return '/omni-search';
	}
};
